import { render, staticRenderFns } from "./DatePassed.vue?vue&type=template&id=f05e962e"
import script from "./DatePassed.vue?vue&type=script&lang=js"
export * from "./DatePassed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports